import { gql } from '@apollo/client';

// language=GraphQL
export default gql(`
  directive @client on FIELD

  interface Highlight {
    id: ID
  }

  #TODO: #405
  interface AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type TimeReportPreferencesDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
    requiredContractId: ContractId!
  }

  type InvoicesDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type AdditionalCostsDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type CopyrightsDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type EditSkillsAndCertificatesDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type EditAddressDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type EditProfileDetailsDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type EditAdditionalDataDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type EditSocialMediaHandlesDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
  }

  type BookDeskDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
    requiredOfficeId: OfficeId!
    prefillRoomId: RoomId
    prefillDeskId: DeskId
    prefillFrom: LocalDate
    prefillTo: LocalDate
  }

  type BookParkingDrawer implements AbstractDrawer {
    id: ID!
    child: AbstractDrawer
    visible: Boolean!
    requiredOfficeId: OfficeId!
    prefillParkingSpotId: ParkingSpotId
    prefillFrom: LocalDate
    prefillTo: LocalDate
  }

  extend type Query {
    drawer(id: ID!): AbstractDrawer
    rootDrawer: AbstractDrawer
    topDrawer: AbstractDrawer
  }
`);
